export default __webpack_public_path__ + "static/media/1879.9b3f0c9b.png";